"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupComponentOverlay = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.PopupComponentOverlay = styled_components_1.default.div `
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  z-index: 15;
`;
//# sourceMappingURL=popup-component-overlay.js.map